import { createContext } from 'react'

const CostsContext = createContext()

export default CostsContext
